var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 5L13.755.755l-1.016 1.016 2.511 2.51H.325v1.437H15.25L12.74 8.23l1.015 1.016L18 5z",
    fill: "#BDC1CF"
  })));
}
export default __webpack_public_path__ + "media/images/arrow_right_3-c4fb907d.svg";
export { SvgArrowRight3 as ReactComponent };